import { CancelButton } from '@core/components/Buttons';
import { SimpleDialog, SimpleDialogContent } from '@core/components/Dialog';
import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import FaturamentoErrosVisualizar from './FaturamentoErrosVisualizar';

const FaturamentoErrosModal = () => {
  const [modalErrosFaturamento, setModalErrosFaturamento] = useContext(GlobalContext).modalErrosFaturamento;
  const [errosFaturamento] = useContext(GlobalContext).errosFaturamento;
  const [errosEmissao] = useContext(GlobalContext).errosEmissao;
  const [errosCancelamento] = useContext(GlobalContext).errosCancelamento;

  const handleCloseModal = () => {
    setModalErrosFaturamento(false);
  };

  const Content = ({ erros }) => {
    return (
      <FaturamentoErrosVisualizar
        erros={erros}
        cancelamento={isCancelamento}
        faturamento={isFaturamento}
        emissao={isEmissao}
      />
    );
  };

  const isCancelamento = errosCancelamento && errosCancelamento.length > 0;
  const isEmissao = errosEmissao && errosEmissao.length > 0;
  const isFaturamento = errosFaturamento && errosFaturamento.length > 0;

  let title = '';

  if (isFaturamento) title = 'Erros de faturamento da Nota Fiscal';
  if (isCancelamento) title = 'Erros de cancelamento da Nota Fiscal';
  if (isEmissao) title = 'Erros de transmissão da Nota Fiscal';

  const defineListaDeErros = () => {
    if (isFaturamento) return errosFaturamento;
    if (isCancelamento) return errosCancelamento;
    if (isEmissao) return errosEmissao;
  };

  return (
    <SimpleDialog open={modalErrosFaturamento === 'modalErrosFaturamento'} onClose={handleCloseModal}>
      <SimpleDialogContent
        header={{
          title,
          toolbar: <CancelButton onClick={handleCloseModal}>Fechar</CancelButton>,
        }}
        content={<Content erros={defineListaDeErros()} />}
      />
    </SimpleDialog>
  );
};

export default FaturamentoErrosModal;
